export default "__VITE_ASSET__BjQYnRu1__"